import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'help-small', 'HelpSmall', [["path",{"d":"M12 16v.01"}],["path",{"d":"M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"}]]);